/* eslint-disable import/no-unresolved */
import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { isEmpty } from 'lodash';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import {
  DwtcVirtualIndustryGlobalIndustryWrapper,
  DwtcVirtualIndustryGlobalIndustryContainer,
  DwtcVirtualIndustryGlobalIndustryBody,
  DwtcVirtualIndustryGlobalIndustryTitle,
  DwtcVirtualIndustryGlobalIndustrySlider,
  DwtcVirtualIndustryGlobalIndustrySliderImage,
} from './DwtcVirtualIndustryGlobalIndustry.styled';

export default function DwtcVirtualIndustryGlobalIndustry({ data, dir }) {
  const breakpoints = {
    0: {
      slidesPerView: 2,
    },
    576: {
      slidesPerView: 3,
    },
    992: {
      slidesPerView: 4,
    },
    1200: {
      slidesPerView: 5,
    },
    1440: {
      slidesPerView: 6,
    },
  };

  return (
    <DwtcVirtualIndustryGlobalIndustryWrapper id={data.contentTypeAlias}>
      <DwtcVirtualIndustryGlobalIndustryContainer>
        <DwtcVirtualIndustryGlobalIndustryBody>
          <DwtcVirtualIndustryGlobalIndustryTitle
            dir={dir}
            dangerouslySetInnerHTML={{ __html: data.sectionContent }}
          />
          <DwtcVirtualIndustryGlobalIndustrySlider>
            <Swiper breakpoints={breakpoints} spaceBetween={30} className="mySwiper">
              {isEmpty(data.dwtcVirtualIndustryGlobalIndustryImages) ||
                data.dwtcVirtualIndustryGlobalIndustryImages.map((item, index) => (
                  <SwiperSlide key={index}>
                    <DwtcVirtualIndustryGlobalIndustrySliderImage>
                      <LazyLoadImage
                        src={item.content.image.url}
                        alt="Virtual Assets"
                        width="100%"
                        height="100%"
                        placeholderSrc={
                          item.content.image
                            ? `${item.content.image.url}?width=50&quality=50`
                            : null
                        }
                      />
                    </DwtcVirtualIndustryGlobalIndustrySliderImage>
                  </SwiperSlide>
                ))}
            </Swiper>
          </DwtcVirtualIndustryGlobalIndustrySlider>
        </DwtcVirtualIndustryGlobalIndustryBody>
      </DwtcVirtualIndustryGlobalIndustryContainer>
    </DwtcVirtualIndustryGlobalIndustryWrapper>
  );
}
